{% block sw_cms_block_acris_blog %}
<div class="sw-cms-block-preview-acris-blog">
    <template v-for="block in 4">
    <sw-cms-product-box-preview :has-text="true" />
    </template>
</div>
{% endblock %}
